module.exports = "data:image/png;base64,UklGRugAAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSBwAAAABDzD/ERGCIICkIfOZZ9IRIvpPMElTbccoDf9tVlA4IKYAAADQBACdASoQABAAAgA0JQBOgrwEcAcID1APyX/gfoB6AtQD9MPQA6gD9AB/5XPaAAD2rN6ejeRVbiKQGdudn5jWsmQNgxn5jWsmQPKh0blgcF6NkoUA/A6oAoIFm/O4HtQkoEma2iKvaScKNHDc+uy2gSa81wIfdMXk+ii5MhNBVyp7SwQ4NQjjs5IdHBux6N7WF0cpB2Cbk3jJBeWgk6qRAXviWAAA"


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Selector.png
// module id = 25
// module chunks = 0